import { HelpdeskService } from "../../../services/helpdesk-service";
import { IHelpdeskUploadDeps, newHelpdeskKey } from "./helpdesk-upload";

export const HELPDESK_UPLOAD_DEPS: IHelpdeskUploadDeps = {
  requestUpload: HelpdeskService.requestUpload,
  putFile: HelpdeskService.putFile,
  completeUpload: HelpdeskService.completeUpload,
  newKey: newHelpdeskKey
};
